import styled from "styled-components";

export const VerticalLine = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
`;

export const Line = styled.div`
	width: 2px;
	height: 100%;
	background-color: #000;
`;

export const ArrowUp = styled.div`
	width: 0;
	height: 0;

	padding: 8px;
	box-shadow: 2px -2px 0 1px #000 inset;
	border: solid transparent;
	border-width: 0 0 2px 2px;
	rotate: 135deg;
	margin-bottom: -15px;
`;

export const ArrowDown = styled.div`
	width: 0;
	height: 0;

	padding: 8px;
	box-shadow: 2px -2px 0 1px #000 inset;
	border: solid transparent;
	border-width: 0 0 2px 2px;
	rotate: -45deg;
	margin-top: -15px;
`;
